module.exports = __webpack_public_path__ + "img/b14.4f5cee97.jpg";